import { ButtonGroupProps } from "./types";

const ButtonGroup: React.FC<ButtonGroupProps> = ({ text }) => {
  return <div className="px-3.5 pt-3 pb-2 text-sm font-semibold text-slate-700 uppercase">{text}</div>;
};

export default ButtonGroup;
